import { render, staticRenderFns } from "./club.vue?vue&type=template&id=0d68bc30&scoped=true&"
import script from "./club.vue?vue&type=script&lang=js&"
export * from "./club.vue?vue&type=script&lang=js&"
import style0 from "./club.vue?vue&type=style&index=0&id=0d68bc30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d68bc30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d68bc30')) {
      api.createRecord('0d68bc30', component.options)
    } else {
      api.reload('0d68bc30', component.options)
    }
    module.hot.accept("./club.vue?vue&type=template&id=0d68bc30&scoped=true&", function () {
      api.rerender('0d68bc30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/viewsBlack/social/search/club.vue"
export default component.exports